import { z } from "zod"

export const ProjectColorSchema = z.enum(["indigo", "blue", "green", "orange", "crimson"])

export const ProjectSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string().nullish(),
  color: ProjectColorSchema,
  created_at: z.string(),
})

export const ProjectFormSchema = z.object({
  name: z.string().nullish(),
  description: z.string().nullish(),
  color: ProjectColorSchema.nullish(),
})

export type Project = z.infer<typeof ProjectSchema>
export type ProjectColor = z.infer<typeof ProjectColorSchema>
export type ProjectForm = z.infer<typeof ProjectFormSchema>
